var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5390_52805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0939 22.6683H5.90724C5.6507 22.6622 5.39787 22.6057 5.16319 22.5019C4.92851 22.3981 4.71659 22.2491 4.53952 22.0633C4.36246 21.8776 4.22373 21.6588 4.13125 21.4194C4.03877 21.1801 3.99437 20.9248 4.00057 20.6683V7.48828H5.3339V20.6683C5.32754 20.7497 5.33734 20.8317 5.36275 20.9093C5.38816 20.987 5.42866 21.0589 5.48195 21.1208C5.53523 21.1828 5.60023 21.2336 5.67322 21.2703C5.7462 21.3071 5.82574 21.329 5.90724 21.3349H18.0939C18.1754 21.329 18.2549 21.3071 18.3279 21.2703C18.4009 21.2336 18.4659 21.1828 18.5192 21.1208C18.5725 21.0589 18.613 20.987 18.6384 20.9093C18.6638 20.8317 18.6736 20.7497 18.6672 20.6683V7.48828H20.0006V20.6683C20.0068 20.9248 19.9624 21.1801 19.8699 21.4194C19.7774 21.6588 19.6387 21.8776 19.4616 22.0633C19.2846 22.2491 19.0726 22.3981 18.838 22.5019C18.6033 22.6057 18.3504 22.6622 18.0939 22.6683Z",
    fill: "#FD2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5194 6.0013H3.33268C3.15587 6.0013 2.9863 5.93106 2.86128 5.80604C2.73625 5.68102 2.66602 5.51145 2.66602 5.33464C2.66602 5.15782 2.73625 4.98826 2.86128 4.86323C2.9863 4.73821 3.15587 4.66797 3.33268 4.66797H20.5194C20.6962 4.66797 20.8657 4.73821 20.9908 4.86323C21.1158 4.98826 21.186 5.15782 21.186 5.33464C21.186 5.51145 21.1158 5.68102 20.9908 5.80604C20.8657 5.93106 20.6962 6.0013 20.5194 6.0013Z",
    fill: "#FD2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8.66797H15.3333V18.668H14V8.66797Z",
    fill: "#FD2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 8.66797H9.99935V18.668H8.66602V8.66797Z",
    fill: "#FD2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3327 3.90536H14.066V2.66536H9.93268V3.90536H8.66602V2.66536C8.66559 2.323 8.79688 1.99358 9.03268 1.74536C9.26849 1.49715 9.59074 1.34915 9.93268 1.33203H14.066C14.408 1.34915 14.7302 1.49715 14.966 1.74536C15.2018 1.99358 15.3331 2.323 15.3327 2.66536V3.90536Z",
    fill: "#FD2222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5390_52805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.4cc03bf9904e34f11ac42f536a24f307.svg";
export { ForwardRef as ReactComponent };